import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { Nav } from '../Nav/Nav.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant, spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var Wrapper = styled(Box).withConfig({
  componentId: "x6phdt-0"
})(["display:flex;overflow:hidden;position:relative;"]);
var ScrollContainer = styled(Box).withConfig({
  componentId: "x6phdt-1"
})(["display:flex;flex:1 1 auto;overflow-x:auto;overflow-y:hidden;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}--left-mask-opacity:1;--right-mask-opacity:1;mask-image:linear-gradient( 90deg,rgba(0,0,0,var(--left-mask-opacity)) 0%,rgba(0,0,0,1) 15%,rgba(0,0,0,1) 85%,rgba(0,0,0,var(--right-mask-opacity)) 100% );"]);
var ScrollButton = styled("button").withConfig({
  componentId: "x6phdt-2"
})(["position:absolute;z-index:1;top:0;bottom:0;display:flex;align-items:center;justify-content:center;width:40px;padding:0;", ";&:hover{cursor:pointer;}"], variant({
  prop: "direction",
  variants: {
    backward: {
      left: 0
    },
    forward: {
      right: 0
    }
  }
}));
var Tablist = styled(Nav).withConfig({
  componentId: "x6phdt-3"
})(["flex:1 1 auto;max-width:unset;min-width:unset;width:auto;", ";"], variant({
  prop: "align",
  variants: {
    left: {
      "& > :last-child": {
        marginRight: "auto"
      }
    },
    right: {
      "& > :first-child": {
        marginLeft: "auto"
      }
    },
    center: {
      "& > :first-child": {
        marginLeft: "auto"
      },
      "& > :last-child": {
        marginRight: "auto"
      }
    }
  }
}));
var Pane = styled(Box).attrs(function () {
  return {
    role: "tabpanel"
  };
}).withConfig({
  componentId: "x6phdt-4"
})(["padding-top:", ";"], spacing("xl"));
export { Pane, ScrollButton, ScrollContainer, Tablist, Wrapper };